import React from 'react';
import { Icon } from 'b3';
import NoteBubble from '../NoteBubble';
import { parseMentionsWithAnchor } from '../../../utils/StringUtils';

export default function NoteBubbleWithAvatar({notes, avatar, assignedUser, contact}) {
	if(! notes) return <div />
	return (
		<div>
			<div className="noteBubbleWithAvatar" style={{display: 'flex'}}>
				<div style={{flex: 1, paddingTop: 20}}>
					{notes &&
						<NoteBubble note={
							<span dangerouslySetInnerHTML={{__html: parseMentionsWithAnchor(notes)}}></span>
						} />
					}
					{assignedUser && contact &&
						<div className="noteBubbleWithAvatar__contacted">
							{assignedUser.firstName} <Icon icon="arrow-right" size={18} /> 
							<span>{`${contact.firstName} ${contact.lastName}`}</span>
						</div>
					}
				</div>
				<div>
					{avatar}
				</div>
			</div>
		</div>
	);
}


// WEBPACK FOOTER //
// ./app/components/client-timeline/items/NoteBubbleWithAvatar.js